import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboOperarioPredeterminado`, method: 'GET', body: null, token: token})
}